import { render, staticRenderFns } from "./must-buy-list-group.vue?vue&type=template&id=027c63b4&scoped=true"
import script from "./must-buy-list-group.vue?vue&type=script&lang=js"
export * from "./must-buy-list-group.vue?vue&type=script&lang=js"
import style0 from "./must-buy-list-group.vue?vue&type=style&index=0&id=027c63b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027c63b4",
  null
  
)

export default component.exports